import type { ReactElement } from "react";
import { Link } from "react-router-dom";
import familyHeroImage from "../../assets/images/Hero/family-photography-guides-hero.webp";
import { NewbornGuideCard } from "./components/NewbornGuideCard";
import { UiIcon } from "./components/UiIcons";
import { familyGuides } from "./data/family.data";
import { resourceArticles } from "./data/resourceArticles";
import { ResourceHubSeo } from "./ResourceSeo";
import "./NewbornPages.scss";
import "./FamilyArticle.scss";

const publishedFamilyHrefs = new Set(
  resourceArticles
    .filter((article) => article.category === "family")
    .map((article) => `/resources/${article.category}/${article.slug}/`)
);
const publishedFamilyGuides = familyGuides.filter((guide) => publishedFamilyHrefs.has(guide.href));

export const FamilyHub = (): ReactElement => (
  <main className="newborn-page family-page">
    <ResourceHubSeo category="family" />
    <section className="newborn-hub-hero family-hub-hero">
      <img
        alt="Family sharing a relaxed moment during an outdoor portrait session"
        className="newborn-hub-hero__background"
        src={familyHeroImage}
      />
      <div className="newborn-shell newborn-hub-hero__content">
        <nav aria-label="Breadcrumb" className="newborn-breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <Link to="/resources/">Resources</Link>
          <span>/</span>
          <span>Family</span>
        </nav>
        <p className="family-eyebrow">FAMILY PHOTOGRAPHY GUIDES</p>
        <h1>Family Photography</h1>
        <p>
          Practical, reassuring guidance for photographs that feel connected, comfortable and unmistakably like your
          family.
        </p>
      </div>
    </section>
    <section className="newborn-guides-section newborn-shell family-guides-section">
      <header>
        <div>
          <p className="family-eyebrow">PLAN WITH CONFIDENCE</p>
          <h2>Explore family guides</h2>
        </div>
        <span>Light, clothing and happy children—the three questions worth answering first.</span>
      </header>
      <div className={`newborn-guide-grid family-guide-grid guide-grid--count-${publishedFamilyGuides.length}`}>
        {publishedFamilyGuides.map((guide) => (
          <NewbornGuideCard guide={guide} key={guide.href} />
        ))}
      </div>
      <section className="newborn-cta family-cta">
        <div className="newborn-cta__icon">
          <UiIcon name="camera" />
        </div>
        <div>
          <h2>Ready to plan your family session?</h2>
          <p>Tell me who is coming and what you want these photographs to feel like.</p>
        </div>
        <Link className="newborn-button newborn-button--coral" to="/contact/">
          Start planning <UiIcon name="arrow" />
        </Link>
      </section>
    </section>
  </main>
);
export default FamilyHub;
